import styled from 'styled-components';
import { Card } from 'antd';
import {fadeIn} from '../../../shared/index.js';

const StyledCard = styled(Card)`
  animation: ${fadeIn} .4s both ease-in-out;
`;

export default StyledCard;
